(ns manage.external-template-ocp.db
  (:require [clojure.spec.alpha :as spec]
            [common.form.core :as form]
            [common.validators.core :refer [url?]]
            [phrase.alpha :as p]
            [re-frame.core :as rf]))

(spec/def :template/url
  (spec/and string? url?))

(spec/def :template/width (spec/and int? pos-int?))

(spec/def :template/height (spec/and int? pos-int?))

(spec/def ::value
  (spec/keys :req-un [:template/width :template/height :template/url]))

(p/defphraser string?
  [_ problem key]
  {:message "The field is required"
   :in (:in problem)
   :problem problem})

(p/defphraser int?
  [_ problem key]
  {:message "The field is required"
   :in (:in problem)
   :problem problem})

(p/defphraser pos-int?
  [_ problem key]
  {:message "The field cannot be negative"
   :in (:in problem)
   :problem problem})

(def initial-value
  {:template/url nil
   :template/width nil
   :template/height nil})

(def validate-form
  (rf/enrich
   (form/get-validate-form-fn :external-template-ocp.db ::value)))

(rf/reg-event-fx :external-template-ocp.db/submit-form
  (fn [_ [_ {:template/keys [url] :as template}]]
    (let [extended-url (str url "?_lemonpiPreview")
          template* (merge template
                           #:template {:id url :name url :url extended-url})]
      {:dispatch-n [[:adset-preview.templates/add-templates template*]
                    [:variants-preview.variants/add-external-template template*]
                    [:ocp/close]]})))

(form/register-form {:namespace :external-template-ocp.db
                     :initial-value initial-value
                     :validate-form validate-form
                     :submit-event :external-template-ocp.db/submit-form})

(def use-bind-control (partial form/use-bind-control :external-template-ocp.db))
(def use-error-message (partial form/use-error-message :external-template-ocp.db))
